import moment from 'moment'
import useHooks from './daily-production.hooks'
import { Card } from '../../../components'
import { WrapperContent } from '../../../styles/global.styled'
import {
  Label,
  Header,
  Container,
  ExportButton,
  FilterWrapper,
  HeaderWrapper,
  StyledDatePicker
} from './daily-production.styled'
import { columns } from './columns'
import CustomGrid from './components/Table'
import { ExcelIcon } from '../../../components/svg'
import { DropdownLocSide } from '../../dashboard/dashboard-dropdown.container'

const DailyProduction = () => {
  const { data, methods } = useHooks()
  const column = methods.generateColumns(columns)
  const height = window.innerHeight - 190 > 455 ? window.innerHeight - 190 : 455
  return (
    <WrapperContent>
      <Card>
        <Container>
          <HeaderWrapper>
            <Header>Daily Production</Header>
            <FilterWrapper>
              {/* <Label>Location</Label>
                <StyledDropDown
                  value={data.filter.location}
                  textField='LocationDescription'
                  dataItemKey='LocationID'
                  data={data.UserLocations}
                  onChange={methods.onLocationChange}
                /> */}
              <DropdownLocSide
                position='relative'
                location={data.Location}
                dataList={data.UserLocations}
                setLocation={methods.setLocation}
              />
              <FilterWrapper>
                <Label>Date</Label>
                <StyledDatePicker
                  style={{ height: 40 }}
                  format='dd/MM/yyyy'
                  value={data.filter.date}
                  onChange={methods.onDateChange}
                />
              </FilterWrapper>
              <ExportButton
                onClick={() =>
                  methods.exportData({
                    location: String(data.Location?.LocationID),
                    filterPeriod: moment(data.filter.date).format('YYYY-MM-DD')
                  })
                }
                disabled={data.isExporting}
              >
                <ExcelIcon />
                Export to Excel
              </ExportButton>
            </FilterWrapper>
          </HeaderWrapper>
          <CustomGrid
            height={height}
            columns={column}
            loading={data.pending}
            data={data.dailyProduction}
          />
        </Container>
      </Card>
    </WrapperContent>
  )
}

export default DailyProduction
